import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">观众热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            来自真实观众的观影体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-start gap-4">
                <img
                  src={item.avatar}
                  alt={item.author}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.author}</span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  </div>
                  <div className="flex items-center gap-1 mt-1 mb-2">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary-500/15 text-primary-600 font-medium whitespace-nowrap">
                      {item.movie}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                  <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                    <i className="ri-thumb-up-line w-3 h-3 flex items-center justify-center"></i>
                    <span>{item.likes}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}